import React from "react";
import { Card, Row, Col } from "antd";
import {
  MailOutlined,
  EyeOutlined,
  LinkOutlined,
  SwapOutlined,
} from "@ant-design/icons";

const StatCard = ({ title, value, icon, color, suffix }) => (
  <Card
    className="campaign-stat-card"
    bordered={false}
    style={{
      background: `linear-gradient(135deg, ${color}15 0%, white 100%)`,
      borderRadius: "12px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <div
          style={{ fontSize: "14px", color: "#8c8c8c", marginBottom: "8px" }}
        >
          {title}
        </div>
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#262626" }}>
          {value}
          {suffix && (
            <span style={{ fontSize: "16px", marginLeft: "4px" }}>
              {suffix}
            </span>
          )}
        </div>
      </div>
      <div
        style={{
          padding: "12px",
          borderRadius: "12px",
          background: color + "15",
          color: color,
        }}
      >
        {icon}
      </div>
    </div>
  </Card>
);

const CampaignOverview = ({ overview }) => {
  if (!overview) return null;

  const stats = [
    {
      title: "Total Recipients",
      value: overview.totalRecipients?.toLocaleString(),
      icon: <MailOutlined style={{ fontSize: "24px" }} />,
      color: "#1890ff",
    },
    {
      title: "Open Rate",
      value: overview.openRate?.toFixed(1),
      suffix: "%",
      icon: <EyeOutlined style={{ fontSize: "24px" }} />,
      color: "#52c41a",
    },
    {
      title: "Click Rate",
      value: overview.clickRate?.toFixed(1),
      suffix: "%",
      icon: <LinkOutlined style={{ fontSize: "24px" }} />,
      color: "#722ed1",
    },
    {
      title: "Click to Open Rate",
      value: overview.clickToOpenRate?.toFixed(1),
      suffix: "%",
      icon: <SwapOutlined style={{ fontSize: "24px" }} />,
      color: "#fa8c16",
    },
  ];

  return (
    <Row gutter={[24, 24]}>
      {stats.map((stat, index) => (
        <Col xs={24} sm={12} xl={6} key={index}>
          <StatCard {...stat} />
        </Col>
      ))}
    </Row>
  );
};

export default CampaignOverview;
